import { render, staticRenderFns } from "./SelectRolePermissions.vue?vue&type=template&id=587cf41a&"
import script from "./SelectRolePermissions.vue?vue&type=script&lang=js&"
export * from "./SelectRolePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports